'use client';

import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Solo mostramos el aviso si el usuario aún no ha decidido (ni aceptar ni rechazar).
    try {
      const consent = localStorage.getItem('cookie_consent');
      if (consent !== 'true' && consent !== 'false') {
        setShowBanner(true);
      }
    } catch {
      setShowBanner(true);
    }
  }, []);

  const decide = (accepted: boolean) => {
    try {
      localStorage.setItem('cookie_consent', accepted ? 'true' : 'false');
    } catch {
      /* almacenamiento no disponible: no bloqueamos la navegación */
    }
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t p-4 shadow-lg animate-in slide-in-from-bottom-5">
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-card-foreground">
          Usamos cookies técnicas (necesarias para el inicio de sesión) y algunas de terceros. Puedes
          aceptarlas o rechazarlas. Consulta nuestra{' '}
          <Link to="/legal/politica-de-cookies" className="underline hover:text-primary">
            Política de Cookies
          </Link>.
        </p>
        <div className="flex items-center gap-2 shrink-0">
          <Button onClick={() => decide(false)} size="sm" variant="outline">
            Rechazar
          </Button>
          <Button onClick={() => decide(true)} size="sm">
            Aceptar
          </Button>
        </div>
      </div>
    </div>
  );
}
